import _each from "lodash/each";
import store from "~/js/store/store";
import { gsap, Quint, Circ, Cubic } from "gsap";
import Common from "~/js/common/common";

export default class Stickypin {
  constructor() {
    this.setup();
    this.setupPin();
  }
  setup() {
    this.isPining = false;
    store.subscribe((mutation, state) => {
      if (mutation.type === "scrollY") {
        this.updateVisible();
      } else if (mutation.type === "deviceSizeChanged") {
        location.reload();
      }
    });
  }

  setupPin() {
    const pins = document.querySelectorAll(".js-stickypin");
    if (!pins || !pins.length) {
      return;
    }
    _each(pins, (elm, index) => {
      let onlyPC = elm.getAttribute("data-onlypc") || false;
      // 通常->ヘッダースタイルに変換される場合に指定されている
      let toHeader = elm.getAttribute("data-toheader") || false;
      if (onlyPC && Common.isSPSize()) {
        return;
      }
      let _top = 0;
      let pinSpacer = document.querySelector(".pin-spacer");
      if (pinSpacer) {
        pinSpacer.classList.add("scrollUp");
      }
      gsap.to(elm, {
        scrollTrigger: {
          trigger: elm,
          pin: true,
          pinSpacing: false,
          start: "top " + _top,
          end: "max",
          onEnter: () => {
            this.isPining = true;
            elm.classList.add("scrollUp");
            if (toHeader) {
              elm.classList.add("l-header__selector");
            }
            let pinSpacer = document.querySelector(".pin-spacer");
            if (pinSpacer) {
              pinSpacer.classList.add("scrollUp");
            }
            store.dispatch("updateStickyPin", {
              isPin: true
            });
          },
          onLeaveBack: () => {
            this.isPining = false;
            elm.classList.remove("scrollUp");
            if (toHeader) {
              elm.classList.remove("l-header__selector");
            }
            let pinSpacer = document.querySelector(".pin-spacer");
            if (pinSpacer) {
              pinSpacer.classList.remove("scrollUp");
            }
            store.dispatch("updateStickyPin", {
              isPin: false
            });
          }
        }
      });
    });
  }

  /**
   * ヘッダーと同様の動きをする
   */
  updateVisible() {
    const pins = document.querySelectorAll(".js-stickypin");
    if (store.state.app.scrollY < 160) {
      _each(pins, (elm) => {
        elm.classList.remove("scrolled");
      });
      return;
    }
    if (store.getters["isScrollDown"] && this.isPining) {
      _each(pins, (elm) => {
        elm.classList.add("scrolled");
      });
    } else {
      _each(pins, (elm) => {
        elm.classList.remove("scrolled");
      });
    }
  }
}
